import { __spreadArray as e, __assign as t } from "tslib";
import n from "@emotion/is-prop-valid";
import o, { useRef as r, useState as s, useMemo as i, useEffect as a, useContext as c, useDebugValue as l, createElement as u } from "react";
import p from "shallowequal";
import * as d from "stylis";
import h from "@emotion/unitless";
var f = "undefined" != typeof process && void 0 !== process.env && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
  m = "active",
  y = "data-styled-version",
  v = "6.1.19",
  g = "/*!sc*/\n",
  S = "undefined" != typeof window && "undefined" != typeof document,
  w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV),
  b = {},
  E = /invalid hook call/i,
  N = new Set(),
  P = function (t, n) {
    if ("production" !== process.env.NODE_ENV) {
      var o = n ? ' with the id of "'.concat(n, '"') : "",
        s = "The component ".concat(t).concat(o, " has been created dynamically.\n") + "You may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.\nSee https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.\n",
        i = console.error;
      try {
        var a = !0;
        console.error = function (t) {
          for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
          E.test(t) ? (a = !1, N.delete(s)) : i.apply(void 0, e([t], n, !1));
        }, r(), a && !N.has(s) && (console.warn(s), N.add(s));
      } catch (e) {
        E.test(e.message) && N.delete(s);
      } finally {
        console.error = i;
      }
    }
  },
  _ = Object.freeze([]),
  C = Object.freeze({});
function I(e, t, n) {
  return void 0 === n && (n = C), e.theme !== n.theme && e.theme || t || n.theme;
}
var A = new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]),
  O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  D = /(^-|-$)/g;
function R(e) {
  return e.replace(O, "-").replace(D, "");
}
var T = /(a)(d)/gi,
  k = 52,
  j = function (e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function x(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > k; t = t / k | 0) n = j(t % k) + n;
  return (j(t % k) + n).replace(T, "$1-$2");
}
var V,
  F = 5381,
  M = function (e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  z = function (e) {
    return M(F, e);
  };
function $(e) {
  return x(z(e) >>> 0);
}
function B(e) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e && e || e.displayName || e.name || "Component";
}
function L(e) {
  return "string" == typeof e && ("production" === process.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var G = "function" == typeof Symbol && Symbol.for,
  Y = G ? Symbol.for("react.memo") : 60115,
  W = G ? Symbol.for("react.forward_ref") : 60112,
  q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
  H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
  U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  J = ((V = {})[W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, V[Y] = U, V);
function X(e) {
  return ("type" in (t = e) && t.type.$$typeof) === Y ? U : "$$typeof" in e ? J[e.$$typeof] : q;
  var t;
}
var Z = Object.defineProperty,
  K = Object.getOwnPropertyNames,
  Q = Object.getOwnPropertySymbols,
  ee = Object.getOwnPropertyDescriptor,
  te = Object.getPrototypeOf,
  ne = Object.prototype;
function oe(e, t, n) {
  if ("string" != typeof t) {
    if (ne) {
      var o = te(t);
      o && o !== ne && oe(e, o, n);
    }
    var r = K(t);
    Q && (r = r.concat(Q(t)));
    for (var s = X(e), i = X(t), a = 0; a < r.length; ++a) {
      var c = r[a];
      if (!(c in H || n && n[c] || i && c in i || s && c in s)) {
        var l = ee(t, c);
        try {
          Z(e, c, l);
        } catch (e) {}
      }
    }
  }
  return e;
}
function re(e) {
  return "function" == typeof e;
}
function se(e) {
  return "object" == typeof e && "styledComponentId" in e;
}
function ie(e, t) {
  return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function ae(e, t) {
  if (0 === e.length) return "";
  for (var n = e[0], o = 1; o < e.length; o++) n += t ? t + e[o] : e[o];
  return n;
}
function ce(e) {
  return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function le(e, t, n) {
  if (void 0 === n && (n = !1), !n && !ce(e) && !Array.isArray(e)) return t;
  if (Array.isArray(t)) for (var o = 0; o < t.length; o++) e[o] = le(e[o], t[o]);else if (ce(t)) for (var o in t) e[o] = le(e[o], t[o]);
  return e;
}
function ue(e, t) {
  Object.defineProperty(e, "toString", {
    value: t
  });
}
var pe = "production" !== process.env.NODE_ENV ? {
  1: "Cannot create styled-component for component: %s.\n\n",
  2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
  9: "Missing document `<head>`\n\n",
  10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
  14: 'ThemeProvider: "theme" prop is required.\n\n',
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
  17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n",
  18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`"
} : {};
function de() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  for (var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1) o.push(e[r]);
  return o.forEach(function (e) {
    n = n.replace(/%[a-z]/, e);
  }), n;
}
function he(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
  return "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(de.apply(void 0, e([pe[t]], n, !1)).trim());
}
var fe = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, e.prototype.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, o = n.length, r = o; e >= r;) if ((r <<= 1) < 0) throw he(16, "".concat(e));
        this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
        for (var s = o; s < r; s++) this.groupSizes[s] = 0;
      }
      for (var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++) this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          o = n + t;
        this.groupSizes[e] = 0;
        for (var r = n; r < o; r++) this.tag.deleteRule(n);
      }
    }, e.prototype.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++) t += "".concat(this.tag.getRule(s)).concat(g);
      return t;
    }, e;
  }(),
  me = 1 << 30,
  ye = new Map(),
  ve = new Map(),
  ge = 1,
  Se = function (e) {
    if (ye.has(e)) return ye.get(e);
    for (; ve.has(ge);) ge++;
    var t = ge++;
    if ("production" !== process.env.NODE_ENV && ((0 | t) < 0 || t > me)) throw he(16, "".concat(t));
    return ye.set(e, t), ve.set(t, e), t;
  },
  we = function (e, t) {
    ge = t + 1, ye.set(e, t), ve.set(t, e);
  },
  be = "style[".concat(f, "][").concat(y, '="').concat(v, '"]'),
  Ee = new RegExp("^".concat(f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')),
  Ne = function (e, t, n) {
    for (var o, r = n.split(","), s = 0, i = r.length; s < i; s++) (o = r[s]) && e.registerName(t, o);
  },
  Pe = function (e, t) {
    for (var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split(g), r = [], s = 0, i = o.length; s < i; s++) {
      var a = o[s].trim();
      if (a) {
        var c = a.match(Ee);
        if (c) {
          var l = 0 | parseInt(c[1], 10),
            u = c[2];
          0 !== l && (we(u, l), Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
        } else r.push(a);
      }
    }
  },
  _e = function (e) {
    for (var t = document.querySelectorAll(be), n = 0, o = t.length; n < o; n++) {
      var r = t[n];
      r && r.getAttribute(f) !== m && (Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
  };
function Ce() {
  return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var Ie = function (e) {
    var t = document.head,
      n = e || t,
      o = document.createElement("style"),
      r = function (e) {
        var t = Array.from(e.querySelectorAll("style[".concat(f, "]")));
        return t[t.length - 1];
      }(n),
      s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute(f, m), o.setAttribute(y, v);
    var i = Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
  },
  Ae = function () {
    function e(e) {
      this.element = Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, o = t.length; n < o; n++) {
          var r = t[n];
          if (r.ownerNode === e) return r;
        }
        throw he(17);
      }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return !1;
      }
    }, e.prototype.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return t && t.cssText ? t.cssText : "";
    }, e;
  }(),
  Oe = function () {
    function e(e) {
      this.element = Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t);
        return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
      }
      return !1;
    }, e.prototype.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  De = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  Re = S,
  Te = {
    isServer: !S,
    useCSSOMInjection: !w
  },
  ke = function () {
    function e(e, n, o) {
      void 0 === e && (e = C), void 0 === n && (n = {});
      var r = this;
      this.options = t(t({}, Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && S && Re && (Re = !1, _e(this)), ue(this, function () {
        return function (e) {
          for (var t = e.getTag(), n = t.length, o = "", r = function (n) {
              var r = function (e) {
                return ve.get(e);
              }(n);
              if (void 0 === r) return "continue";
              var s = e.names.get(r),
                i = t.getGroup(n);
              if (void 0 === s || !s.size || 0 === i.length) return "continue";
              var a = "".concat(f, ".g").concat(n, '[id="').concat(r, '"]'),
                c = "";
              void 0 !== s && s.forEach(function (e) {
                e.length > 0 && (c += "".concat(e, ","));
              }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat(g);
            }, s = 0; s < n; s++) r(s);
          return o;
        }(r);
      });
    }
    return e.registerId = function (e) {
      return Se(e);
    }, e.prototype.rehydrate = function () {
      !this.server && S && _e(this);
    }, e.prototype.reconstructWithOptions = function (n, o) {
      return void 0 === o && (o = !0), new e(t(t({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function () {
      return this.tag || (this.tag = (e = function (e) {
        var t = e.useCSSOMInjection,
          n = e.target;
        return e.isServer ? new De(n) : t ? new Ae(n) : new Oe(n);
      }(this.options), new fe(e)));
      var e;
    }, e.prototype.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function (e, t) {
      if (Se(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, e.prototype.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(Se(e), n);
    }, e.prototype.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function (e) {
      this.getTag().clearGroup(Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function () {
      this.tag = void 0;
    }, e;
  }(),
  je = /&/g,
  xe = /^\s*\/\/.*$/gm;
function Ve(e, t) {
  return e.map(function (e) {
    return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function (e) {
      return "".concat(t, " ").concat(e);
    })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = Ve(e.children, t)), e;
  });
}
function Fe(e) {
  var t,
    n,
    o,
    r = void 0 === e ? C : e,
    s = r.options,
    i = void 0 === s ? C : s,
    a = r.plugins,
    c = void 0 === a ? _ : a,
    l = function (e, o, r) {
      return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    },
    u = c.slice();
  u.push(function (e) {
    e.type === d.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace(je, n).replace(o, l));
  }), i.prefix && u.push(d.prefixer), u.push(d.stringify);
  var p = function (e, r, s, a) {
    void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
    var c = e.replace(xe, ""),
      l = d.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
    i.namespace && (l = Ve(l, i.namespace));
    var p = [];
    return d.serialize(l, d.middleware(u.concat(d.rulesheet(function (e) {
      return p.push(e);
    })))), p;
  };
  return p.hash = c.length ? c.reduce(function (e, t) {
    return t.name || he(15), M(e, t.name);
  }, F).toString() : "", p;
}
var Me = new ke(),
  ze = Fe(),
  $e = /*#__PURE__*/o.createContext({
    shouldForwardProp: void 0,
    styleSheet: Me,
    stylis: ze
  }),
  Be = $e.Consumer,
  Le = /*#__PURE__*/o.createContext(void 0);
function Ge() {
  return c($e);
}
function Ye(e) {
  var t = s(e.stylisPlugins),
    n = t[0],
    r = t[1],
    c = Ge().styleSheet,
    l = i(function () {
      var t = c;
      return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
        target: e.target
      }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
        useCSSOMInjection: !1
      })), t;
    }, [e.disableCSSOMInjection, e.sheet, e.target, c]),
    u = i(function () {
      return Fe({
        options: {
          namespace: e.namespace,
          prefix: e.enableVendorPrefixes
        },
        plugins: n
      });
    }, [e.enableVendorPrefixes, e.namespace, n]);
  a(function () {
    p(n, e.stylisPlugins) || r(e.stylisPlugins);
  }, [e.stylisPlugins]);
  var d = i(function () {
    return {
      shouldForwardProp: e.shouldForwardProp,
      styleSheet: l,
      stylis: u
    };
  }, [e.shouldForwardProp, l, u]);
  return /*#__PURE__*/o.createElement($e.Provider, {
    value: d
  }, /*#__PURE__*/o.createElement(Le.Provider, {
    value: u
  }, e.children));
}
var We = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        void 0 === t && (t = ze);
        var o = n.name + t.hash;
        e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
      }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, ue(this, function () {
        throw he(12, String(n.name));
      });
    }
    return e.prototype.getName = function (e) {
      return void 0 === e && (e = ze), this.name + e.hash;
    }, e;
  }(),
  qe = function (e) {
    return e >= "A" && e <= "Z";
  };
function He(e) {
  for (var t = "", n = 0; n < e.length; n++) {
    var o = e[n];
    if (1 === n && "-" === o && "-" === e[0]) return e;
    qe(o) ? t += "-" + o.toLowerCase() : t += o;
  }
  return t.startsWith("ms-") ? "-" + t : t;
}
var Ue = function (e) {
    return null == e || !1 === e || "" === e;
  },
  Je = function (t) {
    var n,
      o,
      r = [];
    for (var s in t) {
      var i = t[s];
      t.hasOwnProperty(s) && !Ue(i) && (Array.isArray(i) && i.isCss || re(i) ? r.push("".concat(He(s), ":"), i, ";") : ce(i) ? r.push.apply(r, e(e(["".concat(s, " {")], Je(i), !1), ["}"], !1)) : r.push("".concat(He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in h || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
  };
function Xe(e, t, n, o) {
  if (Ue(e)) return [];
  if (se(e)) return [".".concat(e.styledComponentId)];
  if (re(e)) {
    if (!re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [e];
    var r = e(t);
    return "production" === process.env.NODE_ENV || "object" != typeof r || Array.isArray(r) || r instanceof We || ce(r) || null === r || console.error("".concat(B(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Xe(r, t, n, o);
  }
  var s;
  return e instanceof We ? n ? (e.inject(n, o), [e.getName(o)]) : [e] : ce(e) ? Je(e) : Array.isArray(e) ? Array.prototype.concat.apply(_, e.map(function (e) {
    return Xe(e, t, n, o);
  })) : [e.toString()];
}
function Ze(e) {
  for (var t = 0; t < e.length; t += 1) {
    var n = e[t];
    if (re(n) && !se(n)) return !1;
  }
  return !0;
}
var Ke = z(v),
  Qe = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n || n.isStatic) && Ze(e), this.componentId = t, this.baseHash = M(Ke, t), this.baseStyle = n, ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
      if (this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = ie(o, this.staticRulesId);else {
          var r = ae(Xe(this.rules, e, t, n)),
            s = x(M(this.baseHash, r) >>> 0);
          if (!t.hasNameForId(this.componentId, s)) {
            var i = n(r, ".".concat(s), void 0, this.componentId);
            t.insertRules(this.componentId, s, i);
          }
          o = ie(o, s), this.staticRulesId = s;
        }
      } else {
        for (var a = M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++) {
          var u = this.rules[l];
          if ("string" == typeof u) c += u, "production" !== process.env.NODE_ENV && (a = M(a, u));else if (u) {
            var p = ae(Xe(u, e, t, n));
            a = M(a, p + l), c += p;
          }
        }
        if (c) {
          var d = x(a >>> 0);
          t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = ie(o, d);
        }
      }
      return o;
    }, e;
  }(),
  et = /*#__PURE__*/o.createContext(void 0),
  tt = et.Consumer;
function nt() {
  var e = c(et);
  if (!e) throw he(18);
  return e;
}
function ot(e) {
  var n = o.useContext(et),
    r = i(function () {
      return function (e, n) {
        if (!e) throw he(14);
        if (re(e)) {
          var o = e(n);
          if ("production" !== process.env.NODE_ENV && (null === o || Array.isArray(o) || "object" != typeof o)) throw he(7);
          return o;
        }
        if (Array.isArray(e) || "object" != typeof e) throw he(8);
        return n ? t(t({}, n), e) : e;
      }(e.theme, n);
    }, [e.theme, n]);
  return e.children ? /*#__PURE__*/o.createElement(et.Provider, {
    value: r
  }, e.children) : null;
}
var rt = {},
  st = new Set();
function it(e, r, s) {
  var i = se(e),
    a = e,
    c = !L(e),
    p = r.attrs,
    d = void 0 === p ? _ : p,
    h = r.componentId,
    f = void 0 === h ? function (e, t) {
      var n = "string" != typeof e ? "sc" : R(e);
      rt[n] = (rt[n] || 0) + 1;
      var o = "".concat(n, "-").concat($(v + n + rt[n]));
      return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h,
    m = r.displayName,
    y = void 0 === m ? function (e) {
      return L(e) ? "styled.".concat(e) : "Styled(".concat(B(e), ")");
    }(e) : m,
    g = r.displayName && r.componentId ? "".concat(R(r.displayName), "-").concat(r.componentId) : r.componentId || f,
    S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d,
    w = r.shouldForwardProp;
  if (i && a.shouldForwardProp) {
    var b = a.shouldForwardProp;
    if (r.shouldForwardProp) {
      var E = r.shouldForwardProp;
      w = function (e, t) {
        return b(e, t) && E(e, t);
      };
    } else w = b;
  }
  var N = new Qe(s, g, i ? a.componentStyle : void 0);
  function O(e, r) {
    return function (e, r, s) {
      var i = e.attrs,
        a = e.componentStyle,
        c = e.defaultProps,
        p = e.foldedComponentIds,
        d = e.styledComponentId,
        h = e.target,
        f = o.useContext(et),
        m = Ge(),
        y = e.shouldForwardProp || m.shouldForwardProp;
      "production" !== process.env.NODE_ENV && l(d);
      var v = I(r, f, c) || C,
        g = function (e, n, o) {
          for (var r, s = t(t({}, n), {
              className: void 0,
              theme: o
            }), i = 0; i < e.length; i += 1) {
            var a = re(r = e[i]) ? r(s) : r;
            for (var c in a) s[c] = "className" === c ? ie(s[c], a[c]) : "style" === c ? t(t({}, s[c]), a[c]) : a[c];
          }
          return n.className && (s.className = ie(s.className, n.className)), s;
        }(i, r, v),
        S = g.as || h,
        w = {};
      for (var b in g) void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y || "development" !== process.env.NODE_ENV || n(b) || st.has(b) || !A.has(S) || (st.add(b), console.warn('styled-components: it looks like an unknown prop "'.concat(b, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var E = function (e, t) {
        var n = Ge(),
          o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
        return "production" !== process.env.NODE_ENV && l(o), o;
      }(a, g);
      "production" !== process.env.NODE_ENV && e.warnTooManyClasses && e.warnTooManyClasses(E);
      var N = ie(p, d);
      return E && (N += " " + E), g.className && (N += " " + g.className), w[L(S) && !A.has(S) ? "class" : "className"] = N, s && (w.ref = s), /*#__PURE__*/u(S, w);
    }(D, e, r);
  }
  O.displayName = y;
  var D = /*#__PURE__*/o.forwardRef(O);
  return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
    get: function () {
      return this._foldedDefaultProps;
    },
    set: function (e) {
      this._foldedDefaultProps = i ? function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
        for (var o = 0, r = t; o < r.length; o++) le(e, r[o], !0);
        return e;
      }({}, a.defaultProps, e) : e;
    }
  }), "production" !== process.env.NODE_ENV && (P(y, g), D.warnTooManyClasses = function (e, t) {
    var n = {},
      o = !1;
    return function (r) {
      if (!o && (n[r] = !0, Object.keys(n).length >= 200)) {
        var s = t ? ' with the id of "'.concat(t, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(e).concat(s, ".\n") + "Consider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), o = !0, n = {};
      }
    };
  }(y, g)), ue(D, function () {
    return ".".concat(D.styledComponentId);
  }), c && oe(D, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0
  }), D;
}
function at(e, t) {
  for (var n = [e[0]], o = 0, r = t.length; o < r; o += 1) n.push(t[o], e[o + 1]);
  return n;
}
var ct = function (e) {
  return Object.assign(e, {
    isCss: !0
  });
};
function lt(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
  if (re(t) || ce(t)) return ct(Xe(at(_, e([t], n, !0))));
  var r = t;
  return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? Xe(r) : ct(Xe(at(r, n)));
}
function ut(n, o, r) {
  if (void 0 === r && (r = C), !o) throw he(1, o);
  var s = function (t) {
    for (var s = [], i = 1; i < arguments.length; i++) s[i - 1] = arguments[i];
    return n(o, r, lt.apply(void 0, e([t], s, !1)));
  };
  return s.attrs = function (e) {
    return ut(n, o, t(t({}, r), {
      attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
    }));
  }, s.withConfig = function (e) {
    return ut(n, o, t(t({}, r), e));
  }, s;
}
var pt = function (e) {
    return ut(it, e);
  },
  dt = pt;
A.forEach(function (e) {
  dt[e] = pt(e);
});
var ht = function () {
  function e(e, t) {
    this.rules = e, this.componentId = t, this.isStatic = Ze(e), ke.registerId(this.componentId + 1);
  }
  return e.prototype.createStyles = function (e, t, n, o) {
    var r = o(ae(Xe(this.rules, t, n, o)), ""),
      s = this.componentId + e;
    n.insertRules(s, s, r);
  }, e.prototype.removeStyles = function (e, t) {
    t.clearRules(this.componentId + e);
  }, e.prototype.renderStyles = function (e, t, n, o) {
    e > 2 && ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
  }, e;
}();
function ft(n) {
  for (var r = [], s = 1; s < arguments.length; s++) r[s - 1] = arguments[s];
  var i = lt.apply(void 0, e([n], r, !1)),
    a = "sc-global-".concat($(JSON.stringify(i))),
    c = new ht(i, a);
  "production" !== process.env.NODE_ENV && P(a);
  var l = function (e) {
    var t = Ge(),
      n = o.useContext(et),
      r = o.useRef(t.styleSheet.allocateGSInstance(a)).current;
    return "production" !== process.env.NODE_ENV && o.Children.count(e.children) && console.warn("The global style component ".concat(a, " was given child JSX. createGlobalStyle does not render children.")), "production" !== process.env.NODE_ENV && i.some(function (e) {
      return "string" == typeof e && -1 !== e.indexOf("@import");
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), o.useLayoutEffect(function () {
      if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function () {
        return c.removeStyles(r, t.styleSheet);
      };
    }, [r, e, t.styleSheet, n, t.stylis]), null;
  };
  function u(e, n, o, r, s) {
    if (c.isStatic) c.renderStyles(e, b, o, s);else {
      var i = t(t({}, n), {
        theme: I(n, r, l.defaultProps)
      });
      c.renderStyles(e, i, o, s);
    }
  }
  return /*#__PURE__*/o.memo(l);
}
function mt(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n[o - 1] = arguments[o];
  "production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var r = ae(lt.apply(void 0, e([t], n, !1))),
    s = $(r);
  return new We(s, r);
}
function yt(e) {
  var n = /*#__PURE__*/o.forwardRef(function (n, r) {
    var s = I(n, o.useContext(et), e.defaultProps);
    return "production" !== process.env.NODE_ENV && void 0 === s && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "'.concat(B(e), '"')), /*#__PURE__*/o.createElement(e, t({}, n, {
      theme: s,
      ref: r
    }));
  });
  return n.displayName = "WithTheme(".concat(B(e), ")"), oe(n, e);
}
var vt = function () {
    function e() {
      var e = this;
      this._emitSheetCSS = function () {
        var t = e.instance.toString();
        if (!t) return "";
        var n = Ce(),
          o = ae([n && 'nonce="'.concat(n, '"'), "".concat(f, '="true"'), "".concat(y, '="').concat(v, '"')].filter(Boolean), " ");
        return "<style ".concat(o, ">").concat(t, "</style>");
      }, this.getStyleTags = function () {
        if (e.sealed) throw he(2);
        return e._emitSheetCSS();
      }, this.getStyleElement = function () {
        var n;
        if (e.sealed) throw he(2);
        var r = e.instance.toString();
        if (!r) return [];
        var s = ((n = {})[f] = "", n[y] = v, n.dangerouslySetInnerHTML = {
            __html: r
          }, n),
          i = Ce();
        return i && (s.nonce = i), [/*#__PURE__*/o.createElement("style", t({}, s, {
          key: "sc-0-0"
        }))];
      }, this.seal = function () {
        e.sealed = !0;
      }, this.instance = new ke({
        isServer: !0
      }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function (e) {
      if (this.sealed) throw he(2);
      return /*#__PURE__*/o.createElement(Ye, {
        sheet: this.instance
      }, e);
    }, e.prototype.interleaveWithNodeStream = function (e) {
      throw he(3);
    }, e;
  }(),
  gt = {
    StyleSheet: ke,
    mainSheet: Me
  };
"production" !== process.env.NODE_ENV && "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native");
var St = "__sc-".concat(f, "__");
"production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window[St] || (window[St] = 0), 1 === window[St] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window[St] += 1);
export { vt as ServerStyleSheet, Be as StyleSheetConsumer, $e as StyleSheetContext, Ye as StyleSheetManager, tt as ThemeConsumer, et as ThemeContext, ot as ThemeProvider, gt as __PRIVATE__, ft as createGlobalStyle, lt as css, dt as default, se as isStyledComponent, mt as keyframes, dt as styled, nt as useTheme, v as version, yt as withTheme };